import { FieldPattern } from '..';

import { FORM_VISIT_DATETIME } from '../../../../constants/FieldTypeConstants';
import { FormFieldsType } from '../../../../types/FieldModelTypes';

import FormFieldWithInitialValue from '../FormFieldWithInitialValue';

class FormVisitDateTimeField extends FormFieldWithInitialValue {
  readonly type: string = FORM_VISIT_DATETIME;
  constructor(fieldData: FormFieldsType) {
    super(fieldData, new Date().toString());
  }

  match<T>(p: FieldPattern<T>): T {
    return p.FormVisitDateTimeField(this);
  }
}

export default FormVisitDateTimeField;
